import {Orientation} from "@react-pdf/types/page";

import {FormLabelBannerEnum, FormLabelMechanicalEnum} from "../Types";

export const getBannerText = (banner: FormLabelBannerEnum | string, orientation: Orientation): string => {
  return !banner ? ' ' : (
    Array.from({length: getBannerNumber(banner, orientation)}, () => ` - ${banner}`).join('')
  ) + ' -'
}

const getBannerNumber = (banner: FormLabelBannerEnum | string, orientation: Orientation): number => {
  switch (orientation) {
    case 'landscape':
      return 5;
    default:
      return 3;
  }
}

export const getBannerSize = (banner: FormLabelBannerEnum | string, orientation: Orientation): number => {
  switch (orientation) {
    case 'landscape':
      return 16;
    default:
      return 18.5;
  }
}

export const getBannerLetterSpacing = (banner: FormLabelBannerEnum | string, orientation: Orientation): number => {
  switch (orientation) {
    case 'landscape':
      return getBannerLetterSpacingLandscape(banner);
    default:
      return getBannerLetterSpacingPortrait(banner);
  }
}

const getBannerLetterSpacingPortrait = (banner: FormLabelBannerEnum | string): number => {
  switch (banner) {
    case FormLabelBannerEnum.DISCOUNT_OF_MONTH:
      return 1;
    case FormLabelBannerEnum.PRICE_DECREASE:
      return 1.5;
    default:
      return 0;
  }
}

const getBannerLetterSpacingLandscape = (banner: FormLabelBannerEnum | string): number => {
  switch (banner) {
    case FormLabelBannerEnum.DISCOUNT_OF_MONTH:
      return 1;
    case FormLabelBannerEnum.PRICE_DECREASE:
      return 1.5;
    default:
      return 0;
  }
}

export const getAutoTextSize = (
  value: string,
  defaultSize: number,
  maxLengthForDefaultSize: number
): number => {
  if (value.replaceAll(' ', '').length <= maxLengthForDefaultSize) {
    return defaultSize;
  }

  return (defaultSize * maxLengthForDefaultSize) / value.replaceAll(' ', '').length;
}

export const getPdfSimpleDiscountDetailSize = (label: FormLabelMechanicalEnum, orientation: Orientation): number => {
  switch (orientation) {
    case 'landscape':
      return getPdfSimpleDiscountDetailSizeLandscape(label);
    default:
      return getPdfSimpleDiscountDetailSizePortrait(label);
  }
}

const getPdfSimpleDiscountDetailSizePortrait = (label: FormLabelMechanicalEnum): number => {
  switch (label) {
    case FormLabelMechanicalEnum.RANGE_AMOUNT:
    case FormLabelMechanicalEnum.RANGE_PERCENT:
    case FormLabelMechanicalEnum.BRAND_AMOUNT:
    case FormLabelMechanicalEnum.BRAND_PERCENT:
      return 65;
    case FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_SECOND_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_IDENTICAL_PERCENT_THIRD_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_SECOND_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_DIFFERENT_PERCENT_THIRD_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_SECOND_PRODUCT:
    case FormLabelMechanicalEnum.VOLUME_SAME_RANGE_PERCENT_THIRD_PRODUCT:
      return 45;
    default:
      return 80;
  }
}

const getPdfSimpleDiscountDetailSizeLandscape = (label: FormLabelMechanicalEnum): number => {
  return 40;
}
